import { render, staticRenderFns } from "./RelatorioEmpresas.vue?vue&type=template&id=58b8080a&"
import script from "./RelatorioEmpresas.vue?vue&type=script&lang=js&"
export * from "./RelatorioEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports